// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';

export const default_qa = [
    {
        q: 'Which plan is right for me?',
        a: ['We understand that each user is unique, requiring specific '
            +'features to support his needs. Above you can see the features '
            +'included in the different plans to support your needs.'
            +' We believe '
            +'this is the best way to get a decision. Try the product and '
            +'see if you like it or not.'],
    },
    {
        q: 'What if I change my mind?',
        a: ['If you have paid for a yearly account in the last 30 days, and '
            +'for some reason, need to cancel your account, you are entitled '
            +'to a full refund. To receive the refund, simply cancel the '
            +'account and email support@hola.org, explaining you have '
            +'cancelled the account and would like to receive a full refund.'],
    },
    {
        q: 'How can I manage my billing?',
        a: ['Each user of can access to his account and watch the plan '
            +'information, and get an action regarding to his plan.'],
    },
    {
        q: 'Can I use my account on multiple devices?',
        a: ['Yes. Your Hola user account works across all platforms. '
            +'If you purchase one of our Premium plans, you can become a '
            +'"Premium" user up on 10 different devices. There is no need to '
            +'buy a plan for any device. One plan covers all platforms.'],
    },
    {
        q: 'How does our pricing work?',
        a: ['Our pricing is based on 1 variable: the feature plan you’d like '
            +'to use. Once you’ve decided on the feature plan, choose your '
            +'preferred subscription payment: month-to-month or annual. '
            +'Payment is made in one upfront installment (so if you purchase '
            +'a plan for one year, you will pay for one year upfront).'],
    },
    {
        q: 'Do you offer any discounted plans?',
        a: ['Yes, the discounts on annual plans are reflected on this page.'],
    },
    {
        q: 'Can I change my plan?',
        a: ['You can make changes to your plan at any time. To change your '
            +'plan, simply go into the \'account overview\' and find there '
            +'anything you need.'],
    },
    {
        q: 'What payment methods do you accept?',
        a: ['We accept the following payment methods:',
            function Payment_methods({i}){
                return <ul key={i}>
                  <li><p>All the major credit cards - Visa, Master
                    Card, American Express, Discover.</p></li>
                  <li><p>You can also purchase your hola subscription with
                    PayPal.</p></li>
                  <li><p>You can also use your GooglePay.</p></li>
                </ul>;
            }],
    },
];
